export const getMessageTimestamp = (message) => {
  const timestamp = new Date(message?.date).getTime();
  return Number.isFinite(timestamp) ? timestamp : 0;
};

export const sortMessagesChronologically = (messages) => {
  if (!Array.isArray(messages)) return [];

  return messages
    .map((message, index) => ({
      message,
      index,
      timestamp: getMessageTimestamp(message),
    }))
    .sort((left, right) => {
      const dateDelta = left.timestamp - right.timestamp;
      return dateDelta || left.index - right.index;
    })
    .map(({ message }) => message);
};
